import React from "react";
import ProductPageRedesign from "../redesign/ProductPageRedesign";
import { GenericsProductItems } from "./GenericsProductItems";

const GenericsProduct = () => {
  return (
    <ProductPageRedesign
      title="Generics Product"
      description="We identify and understand complexity and challenges in branded formulations. Our development will help to have clinically equivalent products with robust and cost-effective processes, providing affordable medicines to improve the overall quality of life for all patients."
      items={GenericsProductItems}
      bannerImage="https://images.unsplash.com/photo-1584017911766-d451b3d0e843?q=80&w=1920&auto=format&fit=crop"
    />
  );
};

export default GenericsProduct;
